import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Authority = lazy(() => import('./components/Authority').then(m => ({
  default: m.Authority
})));
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const VisualDesire = lazy(() => import('./components/VisualDesire').then(m => ({
  default: m.VisualDesire
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const ValueFraming = lazy(() => import('./components/ValueFraming').then(m => ({
  default: m.ValueFraming
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Aggressively defer Meta Pixel - only after 5 seconds or user interaction
    if (typeof window !== 'undefined') {
      let pixelLoaded = false;
      const loadPixel = () => {
        if (!pixelLoaded) {
          pixelLoaded = true;
          // Use requestIdleCallback for even lower priority
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => initMetaPixel(), {
              timeout: 2000
            });
          } else {
            setTimeout(initMetaPixel, 100);
          }
        }
      };
      // Load on user interaction or after 5 seconds
      const events = ['scroll', 'click', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, loadPixel, {
          once: true,
          passive: true
        });
      });
      const timeout = setTimeout(loadPixel, 5000);
      return () => {
        events.forEach(event => window.removeEventListener(event, loadPixel));
        clearTimeout(timeout);
      };
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body selection:bg-brand-primary/20 selection:text-brand-primary" data-id="element-0" data-mp="3qd0owqaatmn7">
      <Hero data-id="element-1" data-mp="2xu3ku78od0px" />

      <Suspense fallback={null} data-id="element-2" data-mp="2xtv8qhkdlzfs">
        <PainPoints data-id="element-3" data-mp="2xsseq0rrbgvn" />
        <Authority data-id="element-4" data-mp="2svtnbpzh9o15" />
        <ProductOverview data-id="element-5" data-mp="2swbq75gnb0i1" />
        <VisualDesire data-id="element-6" data-mp="2sv0pxfmesavo" />
        <ContentOverview data-id="element-7" data-mp="2stpmxi0sf75m" />
        <Bonuses data-id="element-8" data-mp="18e1ajmuczsl3" />
        <WhatYouGet data-id="element-9" data-mp="18dhrg2sz2y5h" />
        <ValueFraming data-id="element-10" data-mp="18czmmhs8vbly" />
        <Pricing data-id="element-11" data-mp="18cgchn8u5rih" />
        <SocialProof data-id="element-12" data-mp="18bydiiusgz6v" />
        <Guarantee data-id="element-13" data-mp="1d4ztku6qf4s1" />
        <FAQ data-id="element-14" data-mp="1d5jac7knbn4h" />
        <FinalCTA data-id="element-15" data-mp="1d62iiwkhux5b" />
        <Footer data-id="element-16" data-mp="1d6knchl82jou" />
      </Suspense>
    </div>;
}